import { withStyles } from "@material-ui/styles";
import IconList from "Components/IconList";
import LinksList from "Components/LinksList";
import AppConfig from "Config/AppConfig";
import LinksFormModal from "Modals/LinksFormModal";
import React, { Component } from "react";
import styles, {
  ProfileContainer,
  ProfileDetailsContainer,
  ProfileDetailsText,
  ProfilePictureContainer,
  ProjectNumberContainer,
} from "./styles";

class ProfileDetails extends Component {
  state = {
    showVerified: false,
    openLinksForm: false,
    imageError: false,
  };

  addDefaultSrc = (e) => {
    e.target.src = AppConfig.NoProfilePic[0];
    e.target.onerror = null;
  };

  renderProfilePicture = () => {
    const { classes, avatar } = this.props;
    const { imageError } = this.state;

    if (imageError || !avatar) {
      const DefaultPic = AppConfig.NoProfilePic;
      return <DefaultPic className={classes.profileAvatar} />;
    }

    return (
      <img
        src={avatar}
        alt={"Not found"}
        className={classes.profileAvatar}
        onError={this.addDefaultSrc}
      />
    );
  };

  renderLinks = () => {
    return this.props.profileLinks.map(({ resourceLink, resource }, key) => {
      return (
        <IconList
          key={key}
          image={resource.resourceImage}
          onClick={() => (window.location = resourceLink)}
        />
      );
    });
  };

  renderLinkModal = () => {
    const { openLinksForm } = this.state;
    return (
      <LinksFormModal
        show={openLinksForm}
        onHide={() =>
          this.setState({
            openLinksForm: false,
          })
        }
        projectId={1}
      />
    );
  };

  render() {
    const {
      classes,
      publicProfile: { user },
      projectNumber,
      profileLinks,
      avatar,
    } = this.props;
    return (
      <div className={classes.personalDetailsContainer}>
        {this.renderLinkModal()}
        <ProfileContainer>
          <ProfilePictureContainer>
            {this.renderProfilePicture()}
          </ProfilePictureContainer>
          <ProfileDetailsContainer>
            <ProfileDetailsText>{user.firstName}</ProfileDetailsText>
            {projectNumber > 0 && (
              <ProjectNumberContainer>{`${
                projectNumber === 1
                  ? `${projectNumber} Project`
                  : `${projectNumber} Projects`
              }`}</ProjectNumberContainer>
            )}
          </ProfileDetailsContainer>
          <ProfileDetailsContainer>
            <LinksList
              projectResources={profileLinks}
              addOnClick={() => this.setState({ openLinksForm: true })}
              customLinkImage={avatar}
            />
          </ProfileDetailsContainer>
        </ProfileContainer>
      </div>
    );
  }
}

export default withStyles(styles)(ProfileDetails);
